import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faRabbit,
  faBird,
  faFlowerDaffodil,
  faTennisBall,
  faStar,
  faCalendar,
  faDog,
  faHomeAlt,
  faCarSide,
  faCapsules,
  faCat,
  faFishFins,
  faVestPatches,
  faStore,
  faHouseChimneyMedical,
  faWaterLadder,
  faParkingCircle
} from "@fortawesome/pro-solid-svg-icons";

import styles from "./styles.module.scss";
import { BanhoTosa } from "@/utils/svg";

const iconMap = {
  calendar: faCalendar,
  especial: faStar,
  dog: faDog,
  "home-alt": faHomeAlt,
  "car-side": faCarSide,
  "circle-parking": faParkingCircle,
  capsules: faCapsules,
  cat: faCat,
  "flower-daffodil": faFlowerDaffodil,
  rabbit: faRabbit,
  bird: faBird,
  "fish-fins": faFishFins,
  "vest-patches": faVestPatches,
  "tennis-ball": faTennisBall,
  "watter-ladder": faWaterLadder,
  store: faStore,
  "house-chimney-medical": faHouseChimneyMedical
};

interface IconWithTooltipProps {
  icon: string;
  description: string;
  tooltipAlignment?: "left" | "center" | "right";
  onClick?: () => void;
  active?: boolean;
}

const IconWithTooltip: React.FC<IconWithTooltipProps> = ({
  icon,
  description,
  tooltipAlignment = "left",
  onClick,
  active
}) => {
  const fontAwesomeIcon = iconMap[icon as keyof typeof iconMap];

  return (
    <li
      className={`${styles.iconItem} ${active ? styles.active : ""}`}
      onClick={onClick}
    >
      {icon !== "banho-e-tosa" && icon !== "especial" ? (
        <FontAwesomeIcon icon={fontAwesomeIcon} fontSize={19} />
      ) : (
        <div className={styles.iconSvg}>{BanhoTosa}</div>
      )}
      <span className={`${styles.tooltip} ${styles[tooltipAlignment]}`}>
        {description}
      </span>
    </li>
  );
};

export default IconWithTooltip;
